<template>
    <h1 class="dashboard-title">История операции</h1>
    <div class="row pt-4">
        <div class="col-6 col-md-3">
            <div class="form-group">
                <label class="form-label">Период с</label>
                <input type="date" class="form-input" v-model="dateFrom">
            </div>
        </div>
        <div class="col-6 col-md-3">
            <div class="form-group">
                <label class="form-label">Период до</label>
                <input type="date" class="form-input" v-model="dateTo">
            </div>
        </div>
        <div class="col-6 col-md-3">
            <div class="form-group">
                <label class="form-label">Тип операции</label>
                <input type="text" class="form-input" placeholder="Тип операции" readonly :value="selectName" v-on:click="showSelectModal">
            </div>
        </div>
        <div class="col-6 col-md-3">
            <label class="form-label">Поиск</label>
            <button class="button block lg" v-on:click="search" :disabled="loading">Поиск</button>
        </div>
    </div>
    <div class="dashboard-table">
        <div class="row dashboard-table-row table-header h">
            <div class="col-xl-1 dashboard-table-column"></div>
            <div class="col-xl-3 dashboard-table-column">Дата</div>
            <div class="col-xl-3 dashboard-table-column">Тип операции</div>
            <div class="col-xl-2 dashboard-table-column">Сумма</div>
            <div class="col-xl-3 dashboard-table-column">Статус</div>
        </div>
        <div class="row dashboard-table-row nth"></div>
        <template v-if="history">
            <div class="row dashboard-table-row nth md his" v-for="item in history" :key="item" v-on:click="showDetail(item)">
                <div class="col-2 col-md-2 col-xl-1 dashboard-table-column">
                    <img :src="item.logo" :alt="item.slug">
                </div>
                <div class="col-xl-3 dashboard-table-column h">{{ item.date +' '+ item.time }}</div>
                <div class="col-4 col-md-4 col-xl-3 dashboard-table-column his-col">
                    <span>{{ item.type }}</span>
                    <span class="md-block his-date">{{ item.date +' '+ item.time }}</span>
                </div>
                <div class="col-xl-2 dashboard-table-column h">
                    <span v-if="item.operation_type == '1'">{{ item.sum }} {{ item.currency }}</span>
                    <span v-else-if="item.operation_type == '2'">{{ item.debit }} {{ item.currency }}</span>
                    <span v-else-if="item.operation_type == '3'">{{ item.sum }} {{ item.currency }}</span>
                    <span v-else-if="item.operation_type == '4'">{{ item.sum }} {{ item.currency }}</span>
                    <span v-else-if="item.operation_type == '5'">{{ item.sum }} {{ item.currency }}</span>
                    <span v-else-if="item.operation_type == '6'">{{ item.sum }} {{ item.currency }}</span>
                    <span v-else-if="item.operation_type == '7'">{{ item.sum }} {{ item.currency }}</span>
                    <span v-else-if="item.operation_type == '8'">{{ item.sum }} KGS</span>
                    <span v-else-if="item.operation_type == '9'">{{ item.debit }} {{ item.currency }}</span>
                    <span v-else>{{ item.sum }} {{ item.currency }}</span>
                </div>
                <div class="col-6 col-md-6 col-xl-2 dashboard-table-column his-col his-just-end">
                    <span v-if="item.operation_type == '1'" class="md-block">{{ item.sum }} {{ item.currency }}</span>
                    <span v-else-if="item.operation_type == '2'" class="md-block">{{ item.debit }} {{ item.currency }}</span>
                    <span v-else-if="item.operation_type == '3'" class="md-block">{{ item.sum }} {{ item.currency }}</span>
                    <span v-else-if="item.operation_type == '4'" class="md-block">{{ item.sum }} {{ item.currency }}</span>
                    <span v-else-if="item.operation_type == '5'" class="md-block">{{ item.sum }} {{ item.currency }}</span>
                    <span v-else-if="item.operation_type == '6'" class="md-block">{{ item.sum }} {{ item.currency }}</span>
                    <span v-else-if="item.operation_type == '7'" class="md-block">{{ item.sum }} {{ item.currency }}</span>
                    <span v-else-if="item.operation_type == '8'" class="md-block">{{ item.sum }} KGS</span>
                    <span v-else-if="item.operation_type == '9'" class="md-block">{{ item.debit }} {{ item.currency }}</span>
                    <span v-else class="md-block">{{ item.sum }} {{ item.currency }}</span>
                    <span v-if="item.status.value == 1" class="his-status text-warning">{{ item.status.name }}</span>
                    <span v-else-if="item.status.value == 2" class="his-status text-success">{{ item.status.name }}</span>
                    <span v-else-if="item.status.value == 3" class="his-status text-danger">{{ item.status.name }}</span>
                    <span v-else class="his-status">{{ item.status.name }}</span>
                </div>
            </div>
        </template>
        <template v-else>
            <span class="icon-text empty">Нет данных</span>
        </template>
    </div>
    <Select :data="SelectData"></Select>
    <div class="modal-window" v-if="modalStatus">
        <div class="modal-close" v-on:click="closeModal"></div>
        <div class="modal-content">
            <h1 class="modal-title text-center mb-3">Квитанция о платеже</h1>
            <div class="dashboard-table px-0">
                <div class="dashboard-table-row table-row-v2 md">
                    <div class="dashboard-table-column">Дата</div>
                    <div class="dashboard-table-column">{{ detail.date +' '+ detail.time }}</div>
                </div>
                <div class="dashboard-table-row table-row-v2 md">
                    <div class="dashboard-table-column">Тип операции</div>
                    <div class="dashboard-table-column">{{ detail.type }}</div>
                </div>
                <div class="dashboard-table-row table-row-v2 md" v-if="detail.sum">
                    <div class="dashboard-table-column">Сумма</div>
                    <div class="dashboard-table-column">{{ detail.sum }}</div>
                </div>
                <div class="dashboard-table-row table-row-v2 md" v-if="detail.credit">
                    <div class="dashboard-table-column">Сумма к списанию</div>
                    <div class="dashboard-table-column">{{ detail.credit }}</div>
                </div>
                <div class="dashboard-table-row table-row-v2 md" v-if="detail.debit">
                    <div class="dashboard-table-column">Сумма к зачислению</div>
                    <div class="dashboard-table-column">{{ detail.debit }}</div>
                </div>
                <div class="dashboard-table-row table-row-v2 md" v-if="detail.commission">
                    <div class="dashboard-table-column">Комиссия</div>
                    <div class="dashboard-table-column">{{ detail.commission }}</div>
                </div>
                <div class="dashboard-table-row table-row-v2 md" v-if="detail.currency">
                    <div class="dashboard-table-column">Валюта</div>
                    <div class="dashboard-table-column">{{ detail.currency }}</div>
                </div>
            </div>
            <div class="form-group" v-if="detail.batch">
                <label class="form-label">Номер квитанции</label>
                <input type="text" class="form-input" :value="detail.batch" readonly>
            </div>
            <div class="form-group" v-if="detail.requisite">
                <label class="form-label">Реквизит</label>
                <input type="text" class="form-input" :value="detail.requisite" readonly>
            </div>
            <div class="form-group" v-if="detail.memo">
                <label class="form-label">Примечание</label>
                <input type="text" class="form-input" :value="detail.memo" readonly>
            </div>
            <button class="button block lg mt-2" v-on:click="closeModal">Закрыть</button>
        </div>
    </div>
</template>

<script>
import Select from '@/components/Account/Select'

export default {
    data() {
        return {
            modalStatus: false,
            SelectData: {
                title: 'Тип операции',
                list: '',
                ListName: 'name',
                ListValue: 'value'
            },
            detail: '',
            dateFrom: '',
            dateTo: ''
        }
    },
    created() {
        if(this.types) {
            this.SelectData.list = this.types
        }
        this.$store.dispatch('getHistory')
    },
    components: {
        Select
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        selectName() {
            return this.$store.getters.selectName
        },
        types() {
            return (this.$store.getters.getHistoryTypes)
            ? this.$store.getters.getHistoryTypes
            : this.$store.dispatch('getHistoryList')
        },
        history() {
            return this.$store.getters.history
        }
    },
    watch: {
        types() {
            this.SelectData.list = this.types
        }
    },
    methods: {
        showModal() {
            this.modalStatus = true
        },
        closeModal() {
            this.modalStatus = false
        },
        showSelectModal() {
            this.$store.dispatch('setModalStatus', true)
        },
        showDetail(item) {
            if(item.status.value == 2) {
                this.detail = item
                this.showModal()
            }
        },
        search() {
            const data = {
                'operation_type': this.$store.getters.selectValue,
                'date_from': this.dateFrom,
                'date_to': this.dateTo
            }
            this.$store.dispatch('getHistory', data)
        }
    }
}
</script>